import { stringify } from "qs";

export function openInNewWindow(url: string);
export function openInNewWindow(queryArgs: {});
export function openInNewWindow(args: any) {
  const url =
    typeof args === "string"
      ? args
      : `${window.location.origin}${window.location.pathname}?${stringify(args)}`;

  const a = document.createElement("a");
  a.setAttribute("target", "_blank");
  a.setAttribute("href", url);
  a.click();
  a.remove();
}
